import React from 'react'
import {motion} from 'framer-motion'

import './serviceArea.scss'

const ServiceArea = ({serviceArea}) => {
    return <motion.div
        initial={{x: 400}}
        animate={{x: 0}}
        transition={{duration: 0.3}}>
        <div className={'service-area'}>
            {serviceArea.map((s) => <div className={'items'} key={s.name}>
                <label className={'title'}>
                    {s.name}
                </label>
                {s.districts.map((d) => <div className={'div-districts'} key={d.name}>
                    <label className={'label'}>
                        {d.name}
                    </label>
                    <label className={'price'}>
                        {d.deliveryFee.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                    </label>
                </div>)}
            </div>)}
        </div>
    </motion.div>
}

export default ServiceArea
